var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle, withBgClickEvent: true },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", [
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", [
                  _vm._v(
                    " You’re about to " +
                      _vm._s(_vm.modalType) +
                      " " +
                      _vm._s(_vm.selectedVisits.length) +
                      " visits. Once you " +
                      _vm._s(_vm.modalType) +
                      " the visits, they will be removed from your offered visits tab, and your manager will be notified. This cannot be undone. "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "flex flex-col items-end" },
                  [
                    _c("UIButton", {
                      staticClass: "font-outfit",
                      attrs: {
                        processing: _vm.statusProcessing,
                        buttonText: _vm.buttonText,
                        variant: "black",
                        size: "sm",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }